import type { Router } from 'vue-router';

import usePermission from '@/hooks/permission';
// import { useUserStore } from '@/store';
// import { appRoutes } from '../routes';
// import { NOT_FOUND } from '../constants';
import { DEFAULT_ROUTE } from '@/router/constants';
import { NOT_FOUND_ROUTE } from '../routes/base';

export default function setupPermissionGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    // const userStore = useUserStore();
    const Permission = usePermission();
    if (from?.name === 'login') {
      // 登录后重定向的页面没有权限则跳转到默认路由
      if (!Permission.accessRouter(to, 'jump', false)) {
        next(DEFAULT_ROUTE);
        return;
      }
    }
    const permissionsAllow = Permission.accessRouter(to, 'jump');
    if (permissionsAllow) {
      next();
    } else {
      // 先统一设置为 admin 权限，后续再根据权限生成菜单
      // const destination =
      //   Permission.findFirstPermissionRoute(appRoutes, userStore.role) ||
      //   NOT_FOUND;
      // const destination =
      //   Permission.findFirstPermissionRoute(appRoutes, 'admin') || NOT_FOUND;
      // next(destination);
      // 跳转到无权限页面
      if (!from?.name) {
        next(NOT_FOUND_ROUTE);
        return;
      }
      next(false);
    }
  });
}
